import styles from './components/styles.css';

export {
  SCRIPT_TYPES,
  AVAILABLE_DEPENDANCIES,
  GENERATOR_VERSION,
  RUNTIME_TYPES,
} from '../../common/consts.mjs';

function getPrerenderedData() {
  if (ON_SERVER) {
    return {};
  }

  const element = document.querySelector(`script[type="__PREACT_CLI_DATA__"]`);
  if (!element) {
    return {};
  }

  try {
    return JSON.parse(decodeURI(element.textContent)).preRenderData;
  } catch {
    return {};
  }
}

export const ON_SERVER = typeof window === 'undefined';

export const PRERENDERED_DATA = getPrerenderedData();

export const PUBLIC_FOLDER = '/r/clientbackends';

export const ENDPOINT_PATH_PATTERN = '[A-Za-z0-9_][A-Za-z0-9._~-]*';

export const RM_DRAWER_MENU_ITEMS = [
  { caption: 'Dashboard', href: '/r/dashboard/posts' },
  { caption: 'Add Post', href: '/core/community/add_post' },
  { caption: 'Stats', href: '/core/dashboard/stats#overview' },
  { caption: 'Discovery', href: '/core/discovery' },
  { caption: 'Design Tool', href: '/r/layouts-editor/' },
  { caption: 'Bookmarklet', href: '/core/dashboard/bookmarklet' },
];

function _getApiUrl() {
  if (ON_SERVER) {
    return `http://localhost:8080/`;
  } else {
    return `${document.location.origin}/r/kappa/api`;
  }
}

export const API_URL = _getApiUrl();

export const CODE_AREA = {
  BODY_SCHEMA: 'BODY_SCHEMA',
  QUERY_SCHEMA: 'QUERY_SCHEMA',
  HEADERS_SCHEMA: 'HEADERS_SCHEMA',
  COOKIES_SCHEMA: 'COOKIES_SCHEMA',
  SUCCESS_SCHEMA: 'SUCCESS_SCHEMA',
  ERROR_SCHEMA: 'ERROR_SCHEMA',
  SCRIPT: 'SCRIPT',
};

export const METHOD_CLASSNAMES = {
  GET: `${styles.method} ${styles.methodGet}`,
  POST: `${styles.method} ${styles.methodPost}`,
  PUT: `${styles.method} ${styles.methodPut}`,
  PATCH: `${styles.method} ${styles.methodPatch}`,
  DELETE: `${styles.method} ${styles.methodDelete}`,
  HEAD: `${styles.method} ${styles.methodHead}`,
  OPTIONS: `${styles.method} ${styles.methodOptions}`,
};

export const CODE_AREA_TO_LANGUAGE = {
  [CODE_AREA.BODY_SCHEMA]: 'json',
  [CODE_AREA.QUERY_SCHEMA]: 'json',
  [CODE_AREA.HEADERS_SCHEMA]: 'json',
  [CODE_AREA.COOKIES_SCHEMA]: 'json',
  [CODE_AREA.SUCCESS_SCHEMA]: 'json',
  [CODE_AREA.ERROR_SCHEMA]: 'json',
  [CODE_AREA.SCRIPT]: 'javascript',
};

export const EDITOR_MODES = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  CHANGE: 'CHANGE',
};
